var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16411_35498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14C17.75 16.071 16.071 17.75 14 17.75C11.9289 17.75 10.25 16.071 10.25 14C10.25 11.9289 11.9289 10.25 14 10.25",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.65003C15.0153 6.55165 14.5137 6.5 14 6.5C9.85786 6.5 6.5 9.85786 6.5 14C6.5 18.1421 9.85786 21.5 14 21.5C18.1421 21.5 21.5 18.1421 21.5 14C21.5 13.4863 21.4483 12.9847 21.35 12.5",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0234 13.9723L17.4381 10.5576M19.806 8.25887L19.3911 6.76852C19.3147 6.52299 19.0193 6.42514 18.8201 6.58787C17.7431 7.46804 16.5698 8.65359 17.528 10.5235C19.4585 11.4238 20.5607 10.2098 21.4057 9.18938C21.5738 8.98636 21.4724 8.68116 21.2192 8.60794L19.806 8.25887Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16411_35498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsIcon);
export default __webpack_public_path__ + "static/media/leads-icon.d484571187a5a6ec9df98a1025fc127c.svg";
export { ForwardRef as ReactComponent };